// extracted by mini-css-extract-plugin
export var fullWidthButton = "_gm-0";